import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import {Space} from 'antd';
import {
  StyledTransactionDetails,
  StyledTransactionDetailsAvatar,
} from './StyledTransactionDetails';
import {amountHelpers, dateHelpers, transactionsHelpers} from '../../../../utils/helpers';

const TransactionDetails = ({
  isOutside = false,
  transaction = {},
  ...rest
}) => {

  const {
    source = '',
    description = '',
    amount = 0,
    is_incoming: isIncoming = false,
    created_date: createdDate,
  } = transaction;

  const name = source || description;

  const icon = useMemo(() => transactionsHelpers.getTransactionTypeIcon(transaction, isOutside), [transaction, isOutside]);

  const date = useMemo(() => (
    createdDate ? dateHelpers.getDateWithMonth(createdDate, 'DD MMM YYYY') : ''
  ), [createdDate]);

  const formattedAmount = useMemo(() => {
    if (!amount) return '';

    const prefix = !isIncoming && amount > 0 ? '-' : '';
    const formatted = amountHelpers.getAmountWithCurrencyCode(amount);

    return <>{prefix}{formatted}</>;
  }, [amount, isIncoming]);

  return (
    <StyledTransactionDetails
      size={10}
      {...rest}
    >
      <StyledTransactionDetailsAvatar>{icon}</StyledTransactionDetailsAvatar>
      <Space direction='vertical' size={2}>
        <span className='vendor'>{name}</span>
        {!isOutside && (
          <Space size='middle'>
            <span className='date'>{date}</span>
            <span className={`price ${!isIncoming ? 'danger-text' : ''}`}>
              {formattedAmount}
            </span>
          </Space>
        )}
      </Space>
    </StyledTransactionDetails>
  );
}

TransactionDetails.propTypes = {
  isOutside: PropTypes.bool,
  transaction: PropTypes.shape({
    source: PropTypes.string,
    description: PropTypes.string,
    amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    is_incoming: PropTypes.bool,
    created_date: PropTypes.string,
  }),
}

export default TransactionDetails;
